import { NotificationForm } from '../../../../../../notificationForms/sections/notifications/components/NotificationForm'
import { NotificationView } from '../../../../../../notificationForms/sections/notifications/components/NotificationView'

import { NotCompletedNotificationView } from './components/NotCompletedNotificationView'

import { useFormStateController } from '../../hooks/useFormStateController'
import { useNotCompletedNotificationSubmit } from './hooks/useNotCompletedNotificationSubmit'
import { useNotCompletedNotificationToggle } from './hooks/useNotCompletedNotificationToggle'
import { useNotCompletedNotificationValues } from './hooks/useNotCompletedNotificationValues'

import type { FormProps } from '../types'
import { useTexts } from './useTexts'

/**
 * Renders the NotCompleted notification form providing all the domain data and apis.
 */
export function NotCompletedNotification(props: FormProps) {
  const { inEditing, setEditingState } = props

  const values = useNotCompletedNotificationValues()

  const { toggleDescription, onToggle } = useNotCompletedNotificationToggle(values)
  const { edit, cancel } = useFormStateController(setEditingState)
  const onSubmit = useNotCompletedNotificationSubmit()
  const texts = useTexts()

  // Render the Form inside a FormRoot component that will expose the FormState API through a React.Context
  if (inEditing) {
    return (
      <NotificationForm
        notification={'notCompleted'}
        subtitle={texts.description}
        onSubmit={onSubmit}
        title={texts.title}
        cancel={cancel}
        values={values}
      />
    )
  }

  return (
    <NotificationView
      Form={<NotCompletedNotificationView values={values} />}
      toggleSubtitle={toggleDescription}
      notification={'notCompleted'}
      subtitle={texts.description}
      onToggle={onToggle}
      title={texts.title}
      values={values}
      onEdit={edit}
      available
    />
  )
}
